
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAYwwPuXJzyU_gtP-0BVcVKUKuzJAT0bP8",
  authDomain: "fashion-loop-c5354.firebaseapp.com",
  projectId: "fashion-loop-c5354",
  storageBucket: "fashion-loop-c5354.firebasestorage.app",
  messagingSenderId: "946672046980",
  appId: "1:946672046980:web:552a061982e1edec2f83d1",
  measurementId: "G-H0J7TYLZ2Q"
};

const Firebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(Firebase);
const db = getFirestore(Firebase)
export {Firebase,db } 